/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

var processInclude = require('base/util');

require('./util/webpackSetup');

var selectors = {
    selectedPaymentOption: '#selectedPaymentOption',
    dataAttrs: {
        methodId: 'data-method-id'
    },
    activePaymentMethodSelector: '.payment-options .nav-item .active'
};
$(document).ready(function () {
    processInclude(require('./checkout/checkout'));
    if (window.sitePrefs.bopisEnabled) {
        processInclude(require('./storeLocator/storeLocator'));
    }
    if (window.sitePrefs.accessPoint) {
        processInclude(require('./checkout/accessPoint'));
    }
    if (window.sitePrefs.bossEnabled) {
        processInclude(require('./checkout/boss'));
    }
    if (window.sitePrefs.cvsPickupEnabled) {
        processInclude(require('./checkout/convenienceStore'));
    }
    if (window.sitePrefs.yamatoPickupEnabled) {
        processInclude(require('./checkout/yamato'));
    }
    if (window.sitePrefs.peachEMBEnabled || window.sitePrefs.peachCAPEnabled) {
        processInclude(require('./checkout/peachCheckout'));
    }
    if (window.sitePrefs.adyenEnabled) {
        var adyenCheckout = require('../../../../../../../org_newbalance/cartridges/org_adyen_sfra_custom_v24/cartridge/client/default/js/adyenCheckout');
        if (adyenCheckout) {
            adyenCheckout.renderGenericComponent();
        }
        processInclude(require('adyen/checkout/billing'));
        $(selectors.selectedPaymentOption).val($(selectors.activePaymentMethodSelector).parent().attr(selectors.dataAttrs.methodId));
    }
});

if (window.sitePrefs.adyenEnabled) {
    $('.payment-options .nav-link').click(function setAttr() {
        $(selectors.selectedPaymentOption).val($(this).parent().attr(selectors.dataAttrs.methodId));
    });

    // preselect PBL as payment method and hide billing section when its available
    var isPBL = $(selectors.activePaymentMethodSelector).parent().attr(selectors.dataAttrs.methodId) === 'PAYBYLINK';
    if (isPBL) {
        $(selectors.selectedPaymentOption).val('PAYBYLINK');
        $('.billing-address').addClass('d-none');
        $('.address-selector-block').addClass('d-none');
    }
}

var isAmzPayExpressFlow = $('#checkout-main').attr('data-is-amzpay-expressflow') === 'true';
var isAmazonPaySelected = $(selectors.activePaymentMethodSelector).parent().attr(selectors.dataAttrs.methodId) === 'AMAZON_PAY';
if (isAmazonPaySelected && isAmzPayExpressFlow) {
    $(selectors.selectedPaymentOption).val('AMAZON_PAY');
    $('#shippingAddressUseAsBillingAddress').parent('.email-add').addClass('d-none');
    $('.billingAddressSelector').addClass('d-none');
    if (!$('.billing-address').is(':visible')) {
        $('.billing-address').addClass('d-block');
        $('#shippingAddressUseAsBillingAddress').prop('checked', false).trigger('change');
    }
}
